var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 3.84001C8.5 1.99514 9.99514 0.5 11.84 0.5H39.8179L55.5001 13.673V60.16C55.5001 62.0049 54.0049 63.5 52.1601 63.5H11.84C9.99514 63.5 8.5 62.0049 8.5 60.16V3.84001Z",
    stroke: "#D32F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 0V9.59996C40 11.721 41.719 13.44 43.84 13.44H56.0001",
    fill: "#D32F2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1348 40.5439H19.8672V45H17.0986V32.2031H22.1348C23.1484 32.2031 24.0156 32.3877 24.7363 32.7568C25.4629 33.126 26.0195 33.6328 26.4062 34.2773C26.7988 34.916 26.9951 35.6455 26.9951 36.4658C26.9951 37.708 26.5645 38.6982 25.7031 39.4365C24.8418 40.1748 23.6523 40.5439 22.1348 40.5439ZM22.1348 34.4355H19.8672V38.3203H22.1348C22.8613 38.3203 23.3857 38.1504 23.708 37.8105C24.0303 37.4648 24.1914 37.0225 24.1914 36.4834C24.1914 35.9502 24.0303 35.4756 23.708 35.0596C23.3857 34.6436 22.8613 34.4355 22.1348 34.4355Z",
    fill: "#D32F2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7529 45V32.2031H32.7344C33.8887 32.2031 34.9053 32.4609 35.7842 32.9766C36.6689 33.4922 37.3604 34.21 37.8584 35.1299C38.3564 36.0498 38.6055 37.1162 38.6055 38.3291V38.874C38.6055 40.0928 38.3564 41.1621 37.8584 42.082C37.3662 43.002 36.6777 43.7197 35.793 44.2354C34.9082 44.7451 33.8828 45 32.7168 45H28.7529ZM32.7344 34.4355H31.5215V42.7764H32.7168C33.7305 42.7764 34.498 42.4424 35.0195 41.7744C35.5469 41.1064 35.8105 40.1396 35.8105 38.874V38.3115C35.8105 37.04 35.5469 36.0762 35.0195 35.4199C34.498 34.7637 33.7363 34.4355 32.7344 34.4355Z",
    fill: "#D32F2F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2109 45H40.4424V32.2031H48.8359V34.4355H43.2109V37.5996H48.2295V39.8232H43.2109V45Z",
    fill: "#D32F2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.198a8b57.svg";
export { ForwardRef as ReactComponent };